import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { resetTaskListDetailState, getTaskListDetail as onGetTaskListDetails, addNewTaskListDetail as onAddNewTaskListDetail, updateTaskListDetail as onUpdateTaskListDetail, deleteTaskListDetail as onDeleteTaskListDetail, getTaskListDetailLoading } from "../../../store/taskListDetail/action";
import { getTaskList as onGetTaskLists, addNewTaskList as onAddNewTaskList, updateTaskList as onUpdateTaskList, deleteTaskList as onDeleteTaskList, getTaskListLoading, resetTaskListState } from "../../../store/taskList/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

const TaskList = (props) => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clients, clientLoading, taskLists, isTaskListCreated, isTaskListSuccess, loading, error, taskListDetails, taskListDetailLoading, isTaskListDetailCreated, isTaskListDetailSuccess, companies, companyLoading, positions, positionLoading } = useSelector((state) => ({
    taskLists: state.TaskList.taskLists,
    isTaskListCreated: state.TaskList.isTaskListCreated,
    isTaskListSuccess: state.TaskList.isTaskListSuccess,
    loading: state.TaskList.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.TaskList.error,
    taskListDetails: state.TaskListDetail.taskListDetails,
    taskListDetailLoading: state.TaskListDetail.loading,
    isTaskListDetailCreated: state.TaskListDetail.isTaskListDetailCreated,
    isTaskListDetailSuccess: state.TaskListDetail.isTaskListDetailSuccess,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [clientId, setClientId] = useState(0);
  const [taskListList, setTaskListList] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [taskDetailAddedId, setTaskListDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [taskListDetail, setTaskListDetail] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [companyName, setCompanyName] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [taskDetailList, setTaskDetailList] = useState([]);

  const ref = useRef(null);

  const onClickDelete = (taskList) => {
    setTaskList(taskList);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (taskListDetail) => {
    setTaskListDetail(taskListDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteTaskList = () => {
    if (taskList) {
      dispatch(onDeleteTaskList(taskList));
      setDeleteModal(false);
    }
  };

  const handleDeleteTaskListDetail = () => {
    if (taskListDetail) {
      setTaskListDetailAddedId(taskListDetail.taskListId);
      dispatch(onDeleteTaskListDetail(taskListDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setTaskList(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTaskLists = taskLists;
      if (type !== "all") {
        filteredTaskLists = taskLists.filter((taskList) => taskList.task_list_status.name === type);
      }
      setTaskListList(filteredTaskLists);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetTaskListState());
      dispatch(onGetTaskLists());
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      setClientId(obj.data.clientId);
      if (obj?.data) {
        setUserData(obj.data);
        setCompanyName({
          label: obj?.data?.user.user_company.name,
          value: obj?.data?.user.user_company.id,
        });
        if (obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method) {
          setRoles(obj?.data?.user?.user_position?.position_role.method);
        }
      } else setRoles(null);

      // if (obj?.data) setUserType(obj?.data?.userType);
      setUserData(obj.data);
      setUserType(obj?.data?.userType);
      setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
      setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`);
      setClientSelect({
        label: obj.data.client_name,
        value: obj.data.clientId,
      });
      setCompanySelect({
        label: obj.data.company_name,
        value: obj.data.companyId,
      });

      validation.setFieldValue("client", {
        label: obj.data.client_name,
        value: obj.data.clientId,
      });
      validation.setFieldValue("company", {
        label: obj.data.company_name,
        value: obj.data.companyId,
      });

      handleGetCompany(obj.data.clientId);
    }
  }, [dispatch, taskLists, isSearch]);

  useEffect(() => {
    if (!isEmpty(taskLists)) {
      setIsEdit(false);
      let filteredTaskLists = taskLists;
      if (activeTypeTab !== "all") {
        filteredTaskLists = taskLists.filter((taskList) => taskList.task_list_status.name === activeTypeTab);
      }
      setTaskListList(filteredTaskLists);
      let current = 0;
      if (taskDetailAddedId !== 0) {
        taskLists.forEach((obj, i) => {
          if (obj.id === taskDetailAddedId) current = i;
        });
      }
      setInfo(taskLists[current]);
      setTaskDetailList(taskLists[current].task_list_detail);
      // setTaskDetailList(taskLists[current].task_list_company);
    }
  }, [taskLists, taskDetailAddedId]);

  useEffect(() => {
    if (isTaskListDetailCreated) {
      dispatch(resetTaskListDetailState());
      dispatch(resetTaskListState());
      dispatch(onGetTaskLists());
    }
  }, [dispatch, isTaskListDetailCreated]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTaskList(null);
      setClientList([]);
      setCompanyList([]);
      dispatch(resetClientState());
      dispatch(resetCompanyState());
      validation.resetForm();
      validation.setErrors({});
      setIsDisabledUserType(false);
    } else {
      setModal(true);
      dispatch(getClient());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  const handleTaskListClick = useCallback(
    (arg) => {
      const data = arg;
      setTaskList({
        id: data.id,
        name: data.name,
        description: data.description,
        client: data.task_list_client && {
          label: data.task_list_client ? data.task_list_client.name : "",
          value: data.task_list_client ? data.task_list_client.id : "",
        },
        company: data.task_list_company && {
          label: data.task_list_company ? data.task_list_company.name : "",
          value: data.task_list_company ? data.task_list_company.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTaskListDetail(null);
      setTaskList(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleTaskListDetailClick = useCallback(
    (arg, arginfo, isEdit) => {
      const data = arg;

      setTaskListDetail({
        id: data.id,
        taskListId: data.taskListId,
        name: data.name,
        score: data.score,
        description: data.description,
      });

      setIsEditDetail(isEdit);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(cellProps.row.original);
                      setTaskDetailList(cellProps.row.original.task_list_detail);
                      ref.current?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={`btn-sm ${userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").includes("updateTaskList")) ? "" : "d-none"}`}
                    onClick={() => {
                      handleTaskListClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={`btn-sm ${userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").includes("deleteTaskList")) ? "" : "d-none"}`}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approveTaskList") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui pemberhentian untuk ${data.termination_user.user_employee.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "task_list_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [handleTaskListClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: taskListList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={"btn-icon btn btn-sm btn-light edit-item-btn"}
                onClick={() => {
                  handleTaskListDetailClick(cellProps.row.original, info, true);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: `${props.t("Nama")}`,
        accessor: "name",
        filterable: true,
      },
      {
        Header: `${props.t("Score")}`,
        accessor: "score",
        filterable: true,
      },
      {
        Header: `${props.t("Keterangan")}`,
        accessor: "description",
        filterable: true,
      },

      // {
      //   Header: `${props.t("Period")}`,
      //   accessor: "period",
      //   filterable: true,
      // },
      // {
      //   Header: `${props.t("Amount")}`,
      //   accessor: "amount",
      //   filterable: true,
      // },

      // {
      //   Header: `${props.t("Status")}`,
      //   accessor: "billing_status.name",
      //   filterable: true,
      //   Cell: (cell) => {
      //     switch (cell.row.original.statusId) {
      //       case 1:
      //         return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
      //       case 2:
      //         return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
      //       default:
      //         return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
      //     }
      //   },
      // },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleTaskListDetailClick, props, info, taskDetailList]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: taskDetailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const countSecond = preGlobalFilteredRowsSecond.length;
  const [searchValueSecond, setSearchValueSecond] = useState([]);

  const handleApproveTaskList = () => {
    if (taskList) {
      taskList.setApprove = true;
      dispatch(onUpdateTaskList(taskList));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      company: (taskList && taskList.company) || companySelected,
      client: (taskList && taskList.client) || clientSelected,
      name: (taskList && taskList.name) ?? "",
      position: taskList && taskList.position,
      description: (taskList && taskList.description) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Task Name").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getTaskListLoading());
      if (isEdit) {
        const updateTaskList = {
          id: taskList ? taskList.id : 0,
          name: values.name,
          description: values.description,
          clientId: values.client.value,
          companyId: values.company.value,
          statusId: 2,
        };
        dispatch(onUpdateTaskList(updateTaskList));
        validation.resetForm();
      } else {
        const newTaskList = {
          name: values.name,
          description: values.description,
          clientId: values.client.value,
          companyId: values.company.value,
          statusId: 2,
        };
        dispatch(onAddNewTaskList(newTaskList));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      taskListId: info.id,
      name: (taskListDetail && taskListDetail.name) ?? "",
      score: (taskListDetail && taskListDetail.score) ?? "",
      description: (taskListDetail && taskListDetail.description) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Sub Task Title").nullable(true),
      description: Yup.string().required("Please Enter Sub Task Description").nullable(true),
    }),
    onSubmit: (values) => {
      setTaskListDetailAddedId(values.taskListId);
      dispatch(getTaskListDetailLoading());
      if (isEditDetail) {
        const updateTaskListDetail = {
          id: taskListDetail ? taskListDetail.id : 0,
          name: values.name,
          score: values.score,
          description: values.description,
          taskListId: values.taskListId,
        };
        dispatch(onUpdateTaskListDetail(updateTaskListDetail));
        validationDetail.resetForm();
      } else {
        const newTaskListDetail = {
          name: values.name,
          score: values.score,
          description: values.description,
          taskListId: values.taskListId,
        };

        dispatch(onAddNewTaskListDetail(newTaskListDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteTaskListDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetTaskLists(param));
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  // useEffect(() => {
  //   if (userType !== "admin") {
  //     if (companyName) {
  //       dispatch(getPosition({ companyId: companyName.value, status: 2 }));
  //     }
  //   }
  // }, [companyName, userType, dispatch]);

  const setInputType = (type) => {
    if (userData) {
      switch (type) {
        case "user":
          setTaskList({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
            company:
              userData.companyId === null
                ? ""
                : {
                    label: userData.company_name ? userData.company_name : "",
                    value: userData.companyId ? userData.companyId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;
        case "client":
          setTaskList({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
          });
          handleGetCompany(userData.clientId);
          setIsDisabledUserType(true);
          break;
        case "company":
          setTaskList({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
            company:
              userData.companyId === null
                ? ""
                : {
                    label: userData.company_name ? userData.company_name : "",
                    value: userData.companyId ? userData.companyId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;

        default:
          setTaskList("");
          setIsDisabledUserType(false);
          break;
      }
    }
  };

  document.title = "Template Tugas | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={taskList && taskList.name} show={approveModal} onApproveClick={handleApproveTaskList} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTaskList} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteTaskListDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Template Tugas" pageTitle="Penugasan" />
        <Row>
          <Col xxl={6}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Template Tugas&nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createTaskList") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setInputType(userType);
                        setIsEdit(false);
                        toggle();
                      }}
                    >
                      <i className="ri-task-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-task-line me-1 align-bottom fs-14"></i> SEMUA TEMPLATE TUGAS
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col className="col-xxl-3">
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Template Tugas" : "Tambah Template Tugas"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <div className="position-relative">
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                            <div
                              className="position-absolute"
                              style={{
                                top: "12px",
                                left: "-24px",
                              }}
                            >
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          {validation.touched.client && validation.errors.client ? (
                            <p className="invalid-feedback d-block" type="invalid">
                              {validation.errors.client}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <div className="position-relative">
                            <Select
                              Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                            <div
                              className="position-absolute"
                              style={{
                                top: "12px",
                                left: "-24px",
                              }}
                            >
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          {validation.touched.company && validation.errors.company ? (
                            <p className="invalid-feedback d-block" type="invalid">
                              {validation.errors.company}
                            </p>
                          ) : null}
                        </div>
                        {/* /// */}
                        {/* <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;
                            {clientLoading ? (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            // isDisabled={taskType === "Ticket" ? true : false}
                            placeholder="Pilih Grup Usaha"
                            isDisabled={isDisabledUserType}
                            onChange={(e) => {
                              setCompanyList([]);
                              validation.setFieldValue("company", "");
                              validation.setFieldValue("client", e);
                              handleGetCompany(e.value);
                            }}
                            options={clientList}></Select>
                          {validation.touched.client && validation.errors.client ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.client}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;
                            {companyLoading ? (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={companyList.length > 0 ? false : true}
                            onChange={(e) => {
                              validation.setFieldValue("company", e);
                            }}
                            options={companyList}></Select>
                          {validation.touched.company && validation.errors.company ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.company}
                            </small>
                          ) : null}
                        </div> */}
                        {/* /// */}
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name-field" className="form-label">
                            Judul Tugas
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Nama Tugas" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="description-field" className="form-label">
                            Keterangan
                          </Label>
                          <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Ubah Sub Tugas" : "Tambah Sub Tugas"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name-field" className="form-label">
                            Judul Sub Tugas
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Sub Tugas" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.name} invalid={validationDetail.touched.name && validationDetail.errors.name ? true : false} />
                          {validationDetail.touched.name && validationDetail.errors.name ? <FormFeedback type="invalid">{validationDetail.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="score-field" className="form-label">
                            Skor Tugas
                          </Label>
                          <Input name="score" id="score-field" className="form-control" placeholder="Isi Skor Tugas" type="number" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.score} invalid={validationDetail.touched.score && validationDetail.errors.score ? true : false} />
                          {validationDetail.touched.score && validationDetail.errors.score ? <FormFeedback type="invalid">{validationDetail.errors.score}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="description-field" className="form-label">
                            Keterangan
                          </Label>
                          <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.description} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={6}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-success add-btn" : userRole && userRole.split(",").indexOf("createTaskList") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      setIsEditDetail(false);
                      toggleDetail();
                      // var data = [];
                      // var opt = [{ label: "Select All", value: "all" }];
                      // info.pc_detail &&
                      //   info.pc_detail.forEach((item, key) => {
                      //     if (item.component_type === "Allowance") {
                      //       const name = item.name;
                      //       const id = item.id;
                      //       var obj = { label: name, value: id };
                      //       opt.push(obj);
                      //     }
                      //   });
                      // var option = { options: opt };
                      // data.push(option);
                      // setSelectedAllowance(data);
                    }}
                  >
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    {props.t("Tambah")} {props.t("Sub Tugas")}
                  </button>
                  {/* <button
                      className="btn btn-soft-danger"
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                    </button> */}
                </div>
              </div>
              <div className="card-body">
                {/* <Grid
                  data={billingComponentList || []}
                  columns={[
                    {
                      id: "actionchecked",
                      name: _(<input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />),
                      width: "4%",
                      sort: false,
                      data: (row) => row.id,
                      formatter: (cell) => _(<input type="checkbox" className="dataCheckbox form-check-input" value={cell} />),
                    },
                    {
                      name: Nama,
                      data: (row) => row.name,
                      width: "18%",
                    },
                    {
                      name: "Type",
                      width: "10%",
                      data: (row) => row.type,
                    },
                    {
                      name: "Period",
                      width: "14%",
                      data: (row) => row.period,
                    },
                    {
                      name: "Amount",
                      width: "14%",
                      data: (row) => row.amount,
                    },
                    {
                      name: "Status",
                      width: "10%",
                      data: (row) => row,
                      formatter: (cell) => _(<span className={cell.billing_component_status.id === 1 ? "badge text-uppercase badge-soft-danger" : cell.billing_component_status.id === 2 ? "badge text-uppercase badge-soft-info" : "badge text-uppercase badge-soft-warning"}>{cell.billing_component_status.id === 2 ? "ACTIVE" : cell.billing_component_status.id === 1 ? "DRAFT" : ""}</span>),
                    },
                    {
                      name: "action",
                      sort: false,
                      width: "9%",
                      data: (row) => row,
                      formatter: (cell) =>
                        _(
                          <div className="hstack gap-2 mt-4 mt-sm-0">
                            <button
                              className="btn-icon btn btn-sm btn-light edit-item-btn"
                              onClick={() => {
                                handleBillingDetailClick(cell, info, true);
                              }}><i className="ri-edit-2-line fs-15"></i>
                            </button>
                            {cell.statusId !== 2 ? (
                              <button
                                to="#"
                                className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                onClick={() => {
                                  onClickDeleteDetail(cell);
                                }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                              </button>
                            ) : null}
                          </div>
                        ),
                    },
                  ]}
    Search={true}
                  sort={true} /> */}

                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                // onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Cari...`}
                              value={searchValueSecond ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

TaskList.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(TaskList));
